import UploadMediaWithContext from './UploadMediaWithContext'

export default UploadMediaWithContext
